import React, { useState } from 'react';

import MoreOptionsCell from '../../Cards/MoreOptionsCell';
import { Modal } from '../../Modal/Modal';

interface ActionRowWithModalProps {
  data?: any;
  width?: any;
  label: string;
  icon?: React.ReactNode;
  color?: string;
  modalCompFn: (data: any) => React.ReactNode;
  conditionalRenderFn?: (...args: any) => boolean;
}

const ActionRowWithModal: React.FC<ActionRowWithModalProps> = ({
  data,
  label,
  width,
  icon,
  color,
  modalCompFn,
  conditionalRenderFn,
}) => {
  const [showModal, setShowModal] = useState(false);

  if (conditionalRenderFn && conditionalRenderFn(data)) {
    return <></>;
  }

  return (
    <>
      <MoreOptionsCell
        width={width}
        onClick={(e) => {
          e.stopPropagation();
          setShowModal(true);
        }}
        icon={icon}
        color={color}
        label={label}
        hasModal
      />
      <Modal showModal={showModal} setShowModal={setShowModal}>
        {modalCompFn(data)}
      </Modal>
    </>
  );
};

export default ActionRowWithModal;
